export default __webpack_public_path__ + "static/media/captions.189f32c6.svg";